import {
  VENUES_PAGES,
  VIRTUAL_PAGES,
  WELCOME_PAGE,
  USER_PAGE,
  VERTICAL_PAGES,
  ADDITIONAL_REQUESTS_PAGE,
  ADDITIONAL_INFO_PAGES,
  CUSTOMER_PAGES_LOCATION_DECISION,
  CUSTOMER_PAGES_FULL,
  VENUE_LAYOUT_PAGE,
  VENUE_STYLE_PAGE,
  MULTI_VERTICAL_PAGES,
  VIRTUAL_MULTI_VERTICAL_PAGES,
  VENUES_MULTI_VERTICAL_PAGES,
  FLORIST_MULTI_VERTICAL_PAGES,
} from '../pages';

import VERTICAL_PAGES_DATA from '../../../constants/request-form';
import PAGE_TYPES from '../../../constants/request-form/page-types';

const filterPagesOnEventType = (pages, eventType) =>
  pages.filter(
    page =>
      !page.exclusiveToEventTypes?.length ||
      page.exclusiveToEventTypes.includes(eventType)
  );
const getVerticalPages = (tier1, tier2, shouldIncludePrirotityTagPage) => {
  return () => {
    const verticalPages = VERTICAL_PAGES_DATA?.[tier1]?.[tier2];

    if (verticalPages) {
      const filteredPages = verticalPages.filter(page =>
        page.type === PAGE_TYPES.PRIORITY_TAGS
          ? shouldIncludePrirotityTagPage
          : true
      );

      const data = [
        ...filteredPages.map(({ type, ...pageProps }) => ({
          ...VERTICAL_PAGES[type],
          stage: `vertical-stage-${type}`,
          props: pageProps,
        })),
      ];

      if (
        tier2 === 'caterers' ||
        tier2 === 'private_chef' ||
        tier2 === 'street_food' ||
        tier2 === 'event_bar' ||
        tier2 === 'mobile_bar'
      ) {
        // remove description page
        data.pop();
      }

      if (tier2 === 'venues') {
        data.splice(1, 0, VENUE_STYLE_PAGE);
        data.splice(3, 0, VENUE_LAYOUT_PAGE);
      }
      return data;
    }

    return [];
  };
};

const getVerticalPagesByTier = (tier1, tier2, verticalPages, multiVertical) => {
  const midPages = [
    ...verticalPages(),
    ...(ADDITIONAL_INFO_PAGES[tier1]?.[tier2] ?? []),
  ];

  if (tier1 === 'virtual') {
    return multiVertical
      ? [...VIRTUAL_MULTI_VERTICAL_PAGES, ...verticalPages()]
      : [...VIRTUAL_PAGES, ...verticalPages()];
  } else if (tier1 === 'venues') {
    return multiVertical
      ? [...VENUES_MULTI_VERTICAL_PAGES, ...midPages]
      : [...VENUES_PAGES, ...midPages, ADDITIONAL_REQUESTS_PAGE];
  } else if (tier1 === 'florists') {
    return multiVertical
      ? [...FLORIST_MULTI_VERTICAL_PAGES, ...midPages]
      : [
          ...CUSTOMER_PAGES_LOCATION_DECISION,
          ...midPages,
          ADDITIONAL_REQUESTS_PAGE,
        ];
  } else {
    const basePages = multiVertical
      ? MULTI_VERTICAL_PAGES
      : CUSTOMER_PAGES_FULL;

    return multiVertical
      ? [...basePages, ...midPages]
      : [...basePages, ...midPages, ADDITIONAL_REQUESTS_PAGE];
  }
};

export const getPages = (isLoggedIn, tier1, tier2, eventType, pageIncludes) => {
  const verticalPages = getVerticalPages(
    tier1,
    tier2,
    pageIncludes?.shouldIncludePrirotityTagPage
  );
  const pagesByTier = getVerticalPagesByTier(
    tier1,
    tier2,
    verticalPages,
    pageIncludes?.showMultiVerticalPageTest
  );

  const filteredPages = filterPagesOnEventType(pagesByTier, eventType);
  const loggedInUserPages = pageIncludes?.removeEnquiryWelcomePage
    ? [...filteredPages, USER_PAGE]
    : [WELCOME_PAGE, ...filteredPages, USER_PAGE];

  return isLoggedIn ? filteredPages : loggedInUserPages;
};
